import { Component, OnInit, ElementRef, Injector, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
import { ActivatedRoute } from '@angular/router';

/**
 * Component wrapper for OrganisationsController
 */
@Component({
  selector: 'organisations-list',
  template: '<organisations-list-directive></organisations-list-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class OrganisationsListComponent implements OnInit {
  constructor() {}

  ngOnInit() {
    // No specific route params needed for organisations list component
  }
}

/**
 * Directive for downgrading OrganisationsListComponent
 */
@Component({
  selector: 'organisations-list-directive',
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class OrganisationsListDirective extends UpgradeComponent {
  constructor(elementRef: ElementRef, injector: Injector) {
    super('organisationsList', elementRef, injector);
  }
}

/**
 * Component wrapper for OrganisationController
 */
@Component({
  selector: 'organisation-form',
  template: '<organisation-form-directive [orgId]="orgId"></organisation-form-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class OrganisationFormComponent implements OnInit {
  @Input() orgId: string;

  constructor() {}

  ngOnInit() {
    // No specific route params needed for organisation form component
  }
}

/**
 * Directive for downgrading OrganisationFormComponent
 */
@Component({
  selector: 'organisation-form-directive',
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class OrganisationFormDirective extends UpgradeComponent {
  @Input() orgId: string;

  constructor(elementRef: ElementRef, injector: Injector) {
    super('organisationForm', elementRef, injector);
  }
}

/**
 * Component wrapper for OrganisationControlPanelComponent
 */
@Component({
  selector: 'organisation-control-panel-wrapper',
  template: '<organisation-control-panel-directive></organisation-control-panel-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class OrganisationControlPanelComponent implements OnInit {
  constructor() {}

  ngOnInit() {
    // No specific route params needed for organisation control panel component
  }
}

/**
 * Directive for downgrading OrganisationControlPanelComponent
 */
@Component({
  selector: 'organisation-control-panel-directive',
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class OrganisationControlPanelDirective extends UpgradeComponent {
  constructor(elementRef: ElementRef, injector: Injector) {
    super('organisationControlPanel', elementRef, injector);
  }
}

/**
 * Component wrapper for OrganisationSettingsController
 */
@Component({
  selector: 'organisation-settings',
  template: '<organisation-settings-directive [orgId]="orgId"></organisation-settings-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class OrganisationSettingsComponent implements OnInit {
  @Input() orgId: string;

  route = inject(ActivatedRoute);

  constructor() {}

  ngOnInit() {
    // Subscribe to route params to get the organisation ID
    this.route.params.subscribe(params => {
      this.orgId = params['orgId'];
    });
  }
}

/**
 * Directive for downgrading OrganisationSettingsComponent
 */
@Component({
  selector: 'organisation-settings-directive',
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class OrganisationSettingsDirective extends UpgradeComponent {
  @Input() orgId: string;

  constructor(elementRef: ElementRef, injector: Injector) {
    super('organisationSettings', elementRef, injector);
  }
}
